import { PropsWithChildren } from 'react';

import { CircleCheckIcon } from 'lucide-react';

import { cn } from '@/lib/utils';

import styles from './StepFieldset.module.scss';
interface Props {
  title: string;
  step: number;
  status: 'completed' | 'active' | 'disabled';
}

const StepFieldset = ({ title, step, status = 'disabled', children }: PropsWithChildren<Props>) => {
  return (
    <div className={styles.container}>
      <div className={styles.title}>
        {status === 'completed' ? (
          <CircleCheckIcon size={18} className="text-success" />
        ) : (
          <span className={cn('text-sm leading-5 font-normal', styles.step, styles[status])}>
            {step}
          </span>
        )}
        <span className="text-lg leading-7 font-semibold">{title}</span>
      </div>
      <div className={styles.main}>{children}</div>
    </div>
  );
};

export default StepFieldset;
